import { Button, Box, Chip, Skeleton } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation, Pagination, Autoplay } from "swiper";
import "swiper/swiper.scss";
import "swiper/components/navigation/navigation.scss";
import "swiper/components/pagination/pagination.scss";
import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import { rem, goLink } from "assets/js/common";
import { Cookies } from "react-cookie";
import LazyCDNImage from "components/utils/lazy-cdn-image";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import AlertConfirm from "components/ui/alert-confirm";
import { getAppData } from "assets/js/apphandle";
import { loadAlert, loadAppCard } from "redux/reducers/top";

SwiperCore.use([Navigation, Pagination, Autoplay]);

const useStyles = makeStyles((theme) => ({
  banner: {
    "& .center": {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
    "& .main-info": {
      backgroundColor: "#F6F6F6",
      padding: `0 ${rem(20)} ${rem(15)}`,
      "& .mySwiper": {
        paddingBottom: 0,
        margin: `0 ${rem(-20)}`,
        "& .swiper-pagination": {
          display: "none",
        },
        "& .MuiButton-root": {
          width: "100%",
        },
        // "& img": {
        //   objectFit: "cover",
        // },
      },
      "& .MuiChip-root ": {
        position: "absolute",
        top: rem(35),
        left: rem(50),
        // width: rem(34),
        minWidth: rem(34),
        lineHeight: rem(14),
        backgroundColor: "rgba(0, 0, 0, 0.1)",
        padding: `0 ${rem(6)}`,
        zIndex: 1,
        "& .MuiChip-label": {
          fontSize: rem(9),
          fontWeight: 700,
          color: theme.palette.common.black,
        },
      },
      "& .my-benefit": {
        position: "relative",
        margin: `0 0 ${rem(15)}`,
        background: theme.palette.common.white,
        borderRadius: rem(16),
        padding: `${rem(25)} ${rem(30)} ${rem(30)} ${rem(30)}`,
        marginTop: rem(-43),
        zIndex: 1,
        boxShadow: "5px 5px 10px rgba(0, 0, 0, 0.05)",
        "& .header": {
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          "& .benefit-tit": {
            fontSize: rem(14),
            lineHeight: rem(22),
            fontWeight: 700,
            letterSpacing: "-0.5px",
            "& span": {
              color: theme.palette.primary.main,
            },
          },
          "& .benefit-point": {
            fontSize: rem(20),
            lineHeight: rem(26),
            fontWeight: 800,
            "& img": {
              verticalAlign: "middle",
              marginLeft: rem(6),
              width: rem(29),
              height: rem(29),
            },
          },
        },
        "& .content": {
          marginTop: rem(23),
          display: "flex",
          justifyContent: "space-between",
          "& dl": {
            padding: `0 ${rem(10)}`,
            "& dt": {
              fontSize: rem(13),
              lineHeight: rem(18),
            },
            "& dd": {
              textAlign: "center",
              marginTop: rem(5),
              "& a": {
                position: "relative",
                display: "inline",
                fontSize: rem(20),
                fontWeight: 800,
                lineHeight: rem(26),
                "&:after": {
                  display: "block",
                  content: "''",
                  width: "100%",
                  height: "1px",
                  backgroundColor: "#000",
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                },
              },
            },
          },
        },
      },
      "& .my-login": {
        position: "relative",
        margin: `0 0 ${rem(15)} 0`,
        background: theme.palette.common.white,
        borderRadius: rem(16),
        padding: rem(30),
        marginTop: rem(-43),
        zIndex: 1,
        boxShadow: "5px 5px 10px rgba(0, 0, 0, 0.05)",
        "& a": {
          display: "block",
          "& p": {
            fontSize: rem(14),
            lineHeight: rem(22),
            "& + p": {
              marginTop: rem(4),
            },
            "& span": {
              display: "inline",
              fontSize: rem(18),
              fontWeight: 800,
              marginRight: rem(4),
              textDecoration: "underline",
              textUnderlinePosition: "under",
            },
          },
        },
      },
      "& a": {
        width: "100%",
      },
      "& .review": {
        backgroundColor: theme.palette.primary.main,
        boxShadow: "5px 5px 10px rgba(0, 0, 0, 0.05)",
        borderRadius: rem(16),
        padding: `${rem(23)} ${rem(25)} ${rem(23)} ${rem(30)}`,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        "& .cont": {
          fontSize: rem(14),
          color: theme.palette.common.white,
          lineHeight: rem(20),
        },
        "& .btn-rounded": {
          borderRadius: "50px",
          "&.MuiButton-sizeSmall": {
            height: rem(32),
            padding: `0 ${rem(12)} 0 ${rem(16)}`,
            fontSize: rem(14),
            background: theme.palette.common.white,
            color: theme.palette.primary.main,
            letterSpacing: "-0.8px",
            "&.end-icon": {
              fontWeight: 800,
              paddingRight: rem(15),
              "& .MuiButton-endIcon": {
                marginLeft: rem(2),
                "& .ico-go": {
                  width: rem(14),
                  height: rem(14),
                },
              },
            },
          },
        },
      },
      // "& .MuiSkeleton-root": {
      //   borderRadius: 0,
      // },
    },
  },
}));

export default function BannerAndInfo(props) {
  const { goPage } = props;
  const classes = useStyles();
  const cookies = new Cookies();
  const history = useHistory();
  const dispatch = useDispatch();
  const [token, setToken] = useState("");
  const { data, loading } = useSelector((state) => state.home);
  const { accessiblePages } = useSelector((state) => state.user);
  const [mainBannerList, setMainBannerList] = useState([]);
  const imgUrl = "/";

  const handleAlertOpen = (path) => {
    setRedirectPath(path);
    setOpen(true);
  };

  const handleAlertClose = () => {
    setOpen(false);
  };

  const checkLink = (link) => {
    if (link.indexOf("/") == 0) {
      let find = accessiblePages.find((page) => link.indexOf(page) > -1);
      if (find) {
        history.push(link);
      } else {
        if (token) {
          history.push(link);
        } else {
          dispatch(loadAlert(true));
        }
      }
    } else {
      goLink(link);
    }
  };

  useEffect(() => {
    if (data.mainBannerList) setMainBannerList(data.mainBannerList.list);
    // setMainBannerList([
    //   {
    //     imgUrl: "/",
    //     link: "/",
    //   },
    //   {
    //     imgUrl: "/",
    //     link: "/",
    //   },
    //   {
    //     imgUrl: "/",
    //     link: "/",
    //   },
    //   {
    //     imgUrl: "/",
    //     link: "/",
    //   },
    // ]);
  }, [data]);

  useEffect(() => {
    setToken(cookies.get("X-REFRESH-TOKEN") || "");
  }, []);

  if (loading)
    return (
      <div className={classes.banner}>
        <Box className="main-info">
          <div className="mySwiper">
            <Skeleton variant="rectangular" width={"100%"} height={441} />
          </div>
          <div className="my-login">
            <Skeleton variant="text" width={200} height={24} />
            <Skeleton variant="text" width={100} height={24} />
          </div>

          <div className="review">
            <div className="cont">
              <Skeleton variant="text" width={140} height={22} />
            </div>
            <Button
              variant="contained"
              color="primary"
              className="btn-rounded end-icon"
              size="small"
              endIcon={<i className="ico-go" />}
            >
              영수증 리뷰하기
            </Button>
          </div>
        </Box>
      </div>
    );

  return (
    <div className={classes.banner}>
      <Box className="main-info">
        <Swiper
          pagination={true}
          modules={[Autoplay, Pagination]}
          loop={true}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
          infinite={"true"}
          className="mySwiper"
        >
          {mainBannerList.map((banner, i) => (
            <SwiperSlide key={`banner-${i}`}>
              <Chip
                label={`${i + 1} / ${mainBannerList.length}`}
                size="small"
              />
              <Button onClick={() => checkLink(banner.link)}>
                <LazyCDNImage
                  cdnUrl={banner.imgUrl}
                  style={{ width: "100%", minHeight: rem(441) }}
                />
              </Button>
            </SwiperSlide>
          ))}
        </Swiper>

        {Object.keys(data).includes("point") ? (
          <div className="my-benefit">
            <div className="header">
              <div className="benefit-tit">
                <span>오늘의 혜택</span>을 확인하세요
              </div>
              <Button
                onClick={() => dispatch(loadAppCard(true))}
                style={{ minWidth: "auto" }}
              >
                <div className="benefit-point">
                  {data.point.toLocaleString()}P
                  <img
                    src={`${
                      process.env.PUBLIC_URL
                    }/images/icon/icon-appcard.svg`}
                  />
                </div>
              </Button>
            </div>
            <div className="content">
              <dl>
                <dt>쿠폰</dt>
                <dd>
                  <Link to="/coupon">{data.couponCnt}</Link>
                </dd>
              </dl>
              <dl>
                <dt>스탬프</dt>
                <dd>
                  <Link to="/stamp">{data.stampCnt}</Link>
                </dd>
              </dl>
              <dl>
                <dt>이벤트</dt>
                <dd>
                  <Link to="/event">{data.eventCnt}</Link>
                </dd>
              </dl>
            </div>
          </div>
        ) : (
          <div className="my-login">
            <Link to="/login">
              <p>
                <span onClick={() => goPage("/login")}>로그인</span>하시면
              </p>
              <p>메가마트의 많은 혜택을 받을 수 있어요!</p>
            </Link>
          </div>
        )}

        <div className="review">
          <div className="cont">
            행사상품 리뷰로
            <br />
            포인트를 쌓아보세요!
          </div>
          <Button
            variant="contained"
            color="primary"
            className="btn-rounded end-icon"
            size="small"
            endIcon={<i className="ico-go" />}
            onClick={() => goPage("/my-review")}
          >
            영수증 리뷰하기
          </Button>
        </div>
      </Box>
    </div>
  );
}
